import { fetchElasticData } from "../../utility/fetchData";
import { sendAnalyticsData } from "../../utility/levarAnalytics";
import { handleGFX } from '../../utility/featureDetection';
import * as actions from '../actions/index';
import { batch } from 'react-redux';

export const assetStatusThunk = (params) => {
  return async (dispatch) => {

    if(!Object.getOwnPropertyNames(params).length > 0) {
      dispatch(actions.setShadeReady("SHADE_BLOCKED"));
      return;
    };

    const detectEngine = handleGFX();

    batch(() => {
      dispatch(actions.setWidth(window.innerWidth));
      dispatch(actions.setHeight(window.innerHeight));
      dispatch(actions.setEngine(detectEngine));
    });

    if(params.hash) {
      dispatch(actions.setHash(params.hash));
      return true
    };

    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    try {
      let hashURL = `https://eo9muwoz3m.execute-api.us-east-1.amazonaws.com/dev/products/${params.variant}/hash`;
      const hashResponse = await fetch(hashURL);
      if(!hashResponse.ok) { throw new Error(`Error making call to product variant`) }
      const { hash, status, stage } = await hashResponse.json();

      let assetStatus = checkStatus(status, stage);

      if(params.origin === 'external') {
        let esData = await fetchElasticData(params.variant);
        dispatch(actions.setReferrer(esData.referrer));
        dispatch(actions.setProductID(esData.product_id));

        if(params.session_id && isMobile) {
          await sendAnalyticsData({
            session_id: params.session_id,
            hash: hash,
            variant: params.variant,
            event_type: 'qr_button_launch',
            referrer: esData.referrer,
            product_id: esData.product_id
          });
        }
      };

      dispatch(actions.setHash(hash));
      if(params.variant) dispatch(actions.setVariant(params.variant));
      if(params.origin) dispatch(actions.setOrigin(params.origin));
      if(params.session_id) dispatch(actions.setSessionID(params.session_id));

      return assetStatus;
    } catch(error) {
      console.log('error', error);
      dispatch(actions.setShadeReady("SHADE_BLOCKED"));
      return;
    }
  }
};

const checkStatus = (status, stage) => {
  switch (stage) {
    case 4:
      return true
    case 5:
      return status
    default:
      return false
  };
};
